import React from 'react';

import { useParams } from 'react-router-dom';

import CoursePage from './CoursePage';
import StreamPage from './StreamPage';

const AdminCoursePage = () => {
  const { subject, course, stream, lesson } = useParams();

  return (
    <>
      {(subject && course && stream && !lesson) && (
        <StreamPage
          subject={subject}
          course={course}
          stream={stream}
        />
      )}
      {(subject && course && !stream && !lesson) && (
        <CoursePage
          subject={subject}
          course={course}
        />
      )}
    </>
  );
};
export default AdminCoursePage;
